<div class="confirmation-popup">
  <div class="confirmation-popup__body">
    <h2 class="confirmation-popup__title" [innerHTML]="data.title"></h2>
    @if (data.message) {
      <p class="confirmation-popup__message" [innerHTML]="data.message"></p>
    }
  </div>

  <div class="confirmation-popup__actions">
    @if (!data.hideCancelButton) {
      <ptl-button
        data-testid="confirm-dialog-cancel"
        [type]="data.cancelButtonType || 'secondary-neutral'"
        size="s"
        [text]="data.cancelButtonText"
        (clicked)="onCancel()"
      ></ptl-button>
    }
    <ptl-button
      data-testid="confirm-dialog-confirm"
      [type]="data.confirmButtonType || 'primary'"
      size="s"
      [text]="data.confirmButtonText"
      (clicked)="onConfirm()"
    ></ptl-button>
  </div>
</div>
